import * as React from "react";
import { generateUUID } from "../../util";
import { IContextProvider } from "../../uxp";
import {
    addToPath,
    getEditorFields,
    getFieldByIdOrKey,
    getUIFields,
    ISerializedUIField,
    IWDDesignModeProps,
    PropertyPath
} from "./common";
import { SelectableItem } from "./SelectableItem";
import { FAIcon as FontAwesomeIcon } from './components/FAIcon';
import { IQueryConditionGroup, evaluateConditions } from "./query-builder/QueryBuilder";
import { Conditional } from "./ConditionalComponent";
import { VisibilityProperty } from "./ui-props/VisibilityProperty";
import "./field-render.scss";

export function generateSerializedField(id: string): ISerializedUIField {
    let fields = getUIFields();

    const field = fields.find(f => f.id == id)
    if (!field) return null

    const fieldId = generateUUID()
    const fieldProps: any = { ...(field.defaultProps || {}), fieldLabel: { label: fieldId } }
    let serialized: ISerializedUIField = {
        name: fieldId,
        type: field.id,
        metaType: field.type,
        props: fieldProps,  //Object.assign(f.defaultProps || {},{fieldLabel:{label:fieldId}}),
        isInputField: field.isInputField || false,
        id: fieldId,
        droppableContainerId: null,
        dataKey: null,
        propPath: null,
        disableDrop: false,
        onChangeFields: null
    };
    return serialized
}

export function renderField(field: ISerializedUIField, propPath: PropertyPath, globalIndex: number, designer: IWDDesignModeProps, uxpContext: IContextProvider, contextData: any, uiProps: any, onRemove: (f: ISerializedUIField) => void) {
    const dataKey = ''
    const registeredFileds = getEditorFields();
    const _field = getFieldByIdOrKey(field, registeredFileds)

    let _props = { ...field.props }
    // default props that need to pass to fields
    _props.uxpContext = uxpContext
    _props.data = contextData

    const el = React.createElement(_field.field, {
        mode: designer?.mode,
        fieldProps: Object.assign({}, _props),
        uiProps,
        uxpContext,
        designer,
        contextData: contextData,
        onChangeContextData: () => { },
        propPath,
        dataKey,
        droppableParentContainerId: null,
        disableDrop: false,
        onChangeFields: () => { },
    });

    if (!designer || designer?.mode == 'thumbnail' || designer?.mode == 'live') {
        return <Conditional visible={evaluateConditions(field?.props?.visibility || { IsEither: true, Conditions: [], Groups: [] } as IQueryConditionGroup, contextData)} >
            <SelectableItem designer={null} props={[]}>{el}</SelectableItem>
        </Conditional>
    }

    return <div className="uxp_wd-field">
        <SelectableItem
            designer={designer}
            props={[
                {
                    id: addToPath(propPath, globalIndex, 'props', 'visibility'),
                    value: field?.props?.visibility || { IsEither: true, Conditions: [], Groups: [] } as IQueryConditionGroup,
                    definition: VisibilityProperty(field?.props?.visibility || { IsEither: true, Conditions: [], Groups: [] })
                },
                {
                    id: addToPath(propPath, globalIndex, 'props'),
                    value: field.props,
                    definition: { defaults: _field?.defaultProps, render: _field?.propertyEditor }
                }
            ]}
            contextData={contextData}
        >
            {el}
            <div className="uxp_wd-field__remover" onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                onRemove(field)
            }} >
                <FontAwesomeIcon icon={['fas', 'times']} />
            </div>
        </SelectableItem>
    </div>
}
